import type { LoginTranslations } from '../interfaces/login';

export const loginTranslations: LoginTranslations = {
  title: 'Turn your ideas into conversational AI Agents for all your channels',
  subtitle:
    "Start with the leading platform (WhatsApp) and scale easily. {{brand}}'s AI handles sales and support automation.",
  morningMessages: [],
  afternoonMessages: [],
  eveningMessages: [],
  footerMessages: [
    'We created {{brand}} because we believe everyone deserves to build something great without limits. Ready to start?',
    "It doesn't matter where you come from; what matters is what you create. With {{brand}}, the world is your canvas.",
    'We created {{brand}} so your idea can come to life in seconds. Start today.',
    "Every great idea begins with a first step. Today, that step is easier than ever. Let's build the future together!",
    'There are no limits when you have the right tools. And now, you have them.',
    'One day, we dreamed of this, and we made it real. Today, we give you the power to do the same.',
    "We started with an idea and a goal: to prove that anything is possible. Now, it's your turn.",
    "We believed we could do it, and here we are. Don't doubt what you can create.",
    'There are no tricks, no secrets—just belief in our idea and hard work. You can do it too.',
    "If we built this from scratch, what's stopping you? Start today.",
    "Don't wait for the perfect moment. We didn't; we just started. Now, it's your turn.",
    'We created {{brand}} to prove that any idea can become reality. Yours too.',
  ],
  google_button: 'Sign in with Google',
  login_button: 'Log in',
  input_user_label: 'Email',
  input_user_placeholder: 'Enter your email',
  input_password_label: 'Password',
  input_password_placeholder: 'Enter your password',
  checkbox_remember_me: 'Remember me',
  login_account_label_prefix: 'Already have an account?',
  login_account_label_button: 'Log in',
  terms_and_conditions: 'Terms and conditions',
  google_forbidden_title: 'Access restricted',
  google_forbidden_description: 'This account cannot sign in to this dashboard.',
};
